module.exports = __webpack_public_path__ + "static/media/09d.b327616e.png";